import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
// import analytics from '../../helpers/analytics'
import container from '../../helpers/container'
import config from 'config'
import {
  ContainerDivs,
  // SignupForm,
  PetitionRotatingTweet,
  PlanScorecardTakeActionShare,
  PlanScorecardToActionCenter,
  // Link,
  // LinkIcon
} from '../../components'
import Styles from './ComcastPetitionThanks.css'


@CSSModules(Styles, {allowMultiple:true})
export default class ComcastPetitionThanks extends Component {
  constructor(props){
    super(props)
    this.state = {
      tweets: [
        {
          jsx: (
            <span>
              I just signed a petition from @AsYouSow: @Comcast, Stop Investing Employee Savings into Prisons! Join me by signing here #RacialJustice #InvestYourValues <span style={{ textDecoration: 'underline' }}>investyourvalues.org/comcast</span>
            </span>
          ),
          plainText: 'I just signed a petition from @AsYouSow: @Comcast, Stop Investing Employee Savings into Prisons! Join me by signing here #RacialJustice #InvestYourValues'
        },
        {
          jsx: (
            <span>
              It’s time @Comcast stops investing employee savings into private prisons! Join me and @AsYouSow by signing this petition #RacialJustice #InvestYourValues <span style={{ textDecoration: 'underline' }}>investyourvalues.org/comcast</span>
            </span>
          ),
          plainText: 'It’s time @Comcast stops investing employee savings into private prisons! Join me and @AsYouSow by signing this petition #RacialJustice #InvestYourValues'
        },
        {
          jsx: (
            <span>
              Urge @Comcast management to live up to their public commitments by offering a prison-free default retirement fund! Join me in signing @AsYouSow’s petition #RacialJustice #InvestYourValues <span style={{ textDecoration: 'underline' }}>investyourvalues.org/comcast</span>
            </span>
          ),
          plainText: 'Urge @Comcast management to live up to their public commitments by offering a prison-free default retirement fund! Join me in signing @AsYouSow’s petition #RacialJustice #InvestYourValues'
        }
      ]
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const { tweets } = this.state
    const pageTitle = 'Thanks for your support'
    //
    return (
      <div styleName='gray-bckgrnd'>
        <div styleName='page'>
          {
            container.helmet(
              pageTitle,
              'Thanks for supporting our petition asking Comcast to stop investing employee savings into prisons',
              config.domain + config.routes.comcastPetitionThanks
            )
          }
          <ContainerDivs>

            <h1 styleName='large-page-title'>
              Thank you for your support!
            </h1>

            <PetitionRotatingTweet
              companyName={'Comcast'}
              tweets={tweets}
              url={config.domain + config.routes.comcastPetitionLanding}
            />

            <PlanScorecardTakeActionShare
              url={config.domain + config.routes.comcastPetitionLanding}
              description={'Check out this petition from As You Sow asking Comcast to stop investing employee savings into prisons'}
              petition
            />

          </ContainerDivs>

          <PlanScorecardToActionCenter />

          <br/>
          <br/>
          <br/>
        </div>
      </div>
    )
  }
}
